import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { api } from '../../api';

import {
  fetchProfile,
  selectLoading,
  selectInfo,
} from '../../features/profile/profileSlice';

import { Form, Input, Button, Card, Space, message } from 'antd';
import { Layout } from '../../components/Layout';
import { Spinner } from '../../components/Spinner';
import { IS_ADMIN } from '../../constants';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 12,
    },
  },
};

const tailItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      offset: 6,
      span: 12,
    },
  },
};

export const Settings = () => {
  const dispatch = useDispatch();

  const [ passwordForm ] = Form.useForm();
  const [ passwordUpdating, setPasswordUpdating ] = useState(false);
  const [ updateProfileForm ] = Form.useForm();
  const isAdmin = localStorage.getItem(IS_ADMIN)
  const [ infoUpdating, setInfoUpdating ] = useState(false);

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  const { firstName, lastName, email,iamUsername, s3Filepath, awsPassword, s3Url } = useSelector(selectInfo);

  const profileLoading = useSelector(selectLoading);

  if (profileLoading) return (
    <Spinner />
  );

  const onUpdatePassword = async ({ password, new_password }) => {
    try {
      setPasswordUpdating(true);
      await api('/api/update_password', {
        password,
        new_password,
      });
      message.success("Password updated");
      passwordForm.resetFields();
    } catch (e) {
      console.log(e);
      message.error(e.message);
    } finally {
      setPasswordUpdating(false);
    }
  };

  const onSubmit = async ({ email, firstName, lastName }) => {
    try {
      setInfoUpdating(true);
      await api('/api/update_profile', {
        email : email,
        first_name :firstName,
        last_name : lastName
      });
      message.success("Profile updated");
      dispatch(fetchProfile());
    } catch (e) {
      console.log(e);
      message.error(e.message);
    } finally {
      setInfoUpdating(false);
    }
  };


  return (
    <Layout.Content>
      <Space direction="vertical" size={50} style={{ display: 'flex' }}>
       <Card type="inner" title="AWS Access Details.">
        <Form
          {...formItemLayout}
          size="middle"
          layout="horizontal"
          onFinish={onSubmit}
          form={updateProfileForm}
          initialValues={{ iamUsername, s3Filepath, awsPassword}}>

          {(isAdmin === 'null' || isAdmin === 'false') &&
          <Form.Item label="Aws username" name="iamUsername">
            <Input disabled  />
          </Form.Item>}
          {/* {(isAdmin === 'null' || isAdmin === 'false') &&
          <Form.Item label="Aws console password" name="awsPassword">
            <Input disabled  />
          </Form.Item>} */}
          {(isAdmin === 'null' || isAdmin === 'false') &&
          <Form.Item label="Access FilePath" name="s3Filepath">
            <Input  disabled />
          </Form.Item>}

          {/* {s3Filepath && <Form.Item {...tailItemLayout} style={{ textAlign: 'right'}}> 
            <Button  onClick={() => window.open(s3Url, '_blank')}>Go To Assigned S3 folder</Button>
          </Form.Item>} */}
        </Form>
      </Card>  
      <Card type="inner" title="Update Personal Information">
        <Form
          {...formItemLayout}
          size="middle"
          layout="horizontal"
          onFinish={onSubmit}
          form={updateProfileForm}
          initialValues={{ firstName, lastName, email}}>
          <Form.Item label="First Name" name="firstName">
            <Input placeholder="First Name"/>
          </Form.Item>
          <Form.Item label="Last Name" name="lastName">
            <Input placeholder="Last Name"/>
          </Form.Item>
          <Form.Item label="Email" name="email">
            <Input type="email" placeholder="email"/>
          </Form.Item>
          
          <Form.Item {...tailItemLayout} style={{ textAlign: 'right'}}>
            <Button type="primary" htmlType="submit" loading={ infoUpdating }>Update</Button>
          </Form.Item>
          
        </Form>
      </Card>
      <Card type="inner" title="Update Password">
        <Form
          size="large"
          layout="horizontal"
          onFinish={ onUpdatePassword }
          form={ passwordForm }
          {...formItemLayout}>
          <Form.Item
            label="Current Password"
            name="password"
            rules={[{ required: true, message: 'Please enter your password.' }]}
          >
            <Input.Password autoComplete="current-password" disabled={ passwordUpdating } />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="new_password"
            hasFeedback
            rules={[
              { required: true, message: 'Please enter a new password.' },
              { min: 8, message: 'Must be at least 8 characters long.' },
              {
                pattern: new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,64}$/),
                message: "Must be minimum of three of the following mix of character types: uppercase, lowercase, numbers, and ! @ # $ % ^ & * ( ) _ + - = [ ] { } | ' symbols"
              },
              { max: 64, message: 'Must be at most 64 characters long.' },
            ]}
          >
            <Input.Password autoComplete="new-password" disabled={ passwordUpdating } />
          </Form.Item>
          <Form.Item
            label="Confirm Password"
            name="new_password2"
            dependencies={['new_password']}
            hasFeedback
            rules={[
              { required: true, message: 'Please enter a new password.' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('The two passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" disabled={ passwordUpdating } />
          </Form.Item>
          <Form.Item {...tailItemLayout} style={{ textAlign: 'right'}}>
            <Button type="primary" htmlType="submit" loading={ passwordUpdating }>Update</Button>
          </Form.Item>
        </Form>
      </Card>
      </Space>
    </Layout.Content>
  );
}
